(function () {
  function formatMoney(cents) {
    return (cents / 100).toFixed(2) + "€";
  }

  function getCfg() {
    window.__minOrder = window.__minOrder || {};
    return window.__minOrder;
  }

  function getState() {
    var cfg = getCfg();
    return {
      enabled: !!cfg.enabled,
      min: Number(cfg.minCents || 0),
      total: Number(cfg.cartTotalCents || 0),
      redirectUrl: cfg.redirectUrl || "/"
    };
  }

  function isBelow(state) {
    return state.enabled && state.total < state.min;
  }

  function syncUI() {
    const state = getState();
    const below = isBelow(state);

    document.querySelectorAll("[data-checkout-button]").forEach(function (btn) {
      btn.disabled = below;
      btn.setAttribute("aria-disabled", below ? "true" : "false");
      btn.classList.toggle("is-disabled-by-minimum", below);
    });

    var warning = document.querySelector("[data-minimum-warning]");
    if (warning) {
      if (below) {
        warning.textContent =
          "Minimum order is " + formatMoney(state.min) + ". Add " + formatMoney(state.min - state.total) + " more to checkout.";
        warning.style.display = "";
      } else {
        warning.style.display = "none";
      }
    }
  }

  function blockIfNeeded(e) {
    var btn = e.target.closest("[data-checkout-button], a[href*='/checkout']");
    if (!btn) return;
    var s = getState();
    if (!isBelow(s)) return;
    e.preventDefault();
    if (btn.matches("a[href*='/checkout']")) window.location.href = s.redirectUrl;
  }

  function applyCartUpdate(event) {
    var total = event && event.detail && event.detail.cart && event.detail.cart.total_price;
    if (typeof total === "number") {
      getCfg().cartTotalCents = total;
      syncUI();
      return;
    }

    fetch("/cart.js")
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        getCfg().cartTotalCents = Number(cart.total_price || 0);
        syncUI();
      });
  }

  document.addEventListener("click", blockIfNeeded);
  document.addEventListener("DOMContentLoaded", syncUI);
  document.addEventListener("dialog:opened", syncUI);
  document.addEventListener("cart:update", applyCartUpdate);
})();
